angular
  .module('surfsightApp.controllers')
  .controller('healthReportsListController', [
    '$scope',
    '$rootScope',
    '$log',
    '$state',
    '$timeout',
    '$interval',
    '$location',
    '$http',
    '$filter',
    '$localStorage',
    '$mdDialog',
    '$mdMedia',
    '$mdSidenav',
    '$mdToast',
    '$mdColors',
    'edgeFactory',
    'edgeGroupFactory',
    'leafletData',
    '$stateParams',
    function (
      $scope,
      $rootScope,
      $log,
      $state,
      $timeout,
      $interval,
      $location,
      $http,
      $filter,
      $localStorage,
      $mdDialog,
      $mdMedia,
      $mdSidenav,
      $mdToast,
      $mdColors,
      edgeFactory,
      edgeGroupFactory,
      leafletData,
      $stateParams
    ) {
      $scope.localStorage = $localStorage
      $scope.healthReportsList = angular.copy(window.healthReportsList)
      $scope.alarmsExists = $rootScope.alarmsCount
      $scope.goBack = function () {
        $state.go('home.common.edge.list')
      }
      $scope.selectedHealthReport = null
      $scope.showHealthReport = function (report) {
        $location.url($location.path())
        if (!$mdMedia('gt-sm')) {
          $state.go('home.common.healthReports', {
            healthReportType: report.id
          })
        } else {
          $scope.$emit('healthReportType', { type: report.id })
        }
        $scope.selectedHealthReport = report
      }
      $scope.hideHealthSidenav = function () {
        $state.go('home.common.health')
      }
    }
  ])
